import keyDel from 'key-del'
import {get, post, del} from '../requestUtils'

export function getProducts(projectId, pageNo = 0, size = 0, filter = {}) {
  return get(
    `/ecommerce/project/${projectId}/products?pageNo=${pageNo}&size=${size}&filter=${JSON.stringify(
      filter,
    )}`,
  )
}

export function postProduct(userProjectId, body) {
  const request = keyDel(body, [
    'id',
    'createdAt',
    'productId',
    'createdAt',
    'updatedAt',
    'inventory',
    'transactions',
    'reserved',
  ])
  return post(`/ecommerce/project/${userProjectId}/product`, {product: request})
}

export function deleteProduct(projectId, productId) {
  return del(`/ecommerce/project/${projectId}/product/${productId}`)
}

export function editProduct(userProjectId, body) {
  const productId = body.id
  return post(`/ecommerce/project/${userProjectId}/product/${productId}`, {
    product: keyDel(body, [
      'createdAt',
      'updatedAt',
      'inventory',
      'transactions',
      'reserved',
    ]),
  })
}

export function getStoreSettings(projectId) {
  return get(`/ecommerce/project/${projectId}/store`)
}

export function postStoreSettings(projectId, body) {
  return post(`/ecommerce/project/${projectId}/store`, body)
}

export function postUpdateStock(projectId, productSKUId, action, quantity) {
  const value = action === 'dec' ? -quantity : quantity
  return post(
    `/ecommerce/project/${projectId}/productSKU/${productSKUId}/inventory`,
    {value},
  )
}

export function getOrder(projectId) {
  return get(`/ecommerce/project/${projectId}/order`)
}

export function approveReceipt(projectId, orderId, body) {
  return post(`/ecommerce/project/${projectId}/order/${orderId}`, {
    action: 'approveReceipt',
    data: {
      state: 'PREPARE_TO_SHIPPING',
      bill: {},
      paymentAt: new Date(body.paymentAt),
      paymentAmount: body.paymentAmount,
      paymentBankName: body.paymentBankName,
    },
  })
}

export function rejectReceipt(projectId, orderId, reason) {
  return post(`/ecommerce/project/${projectId}/order/${orderId}`, {
    action: 'rejectReceipt',
    data: {
      reason: 'WRONG_IMAGE',
    },
  })
}

export function shipped(projectId, orderId, body) {
  return post(`/ecommerce/project/${projectId}/order/${orderId}`, {
    action: 'shipped',
    data: {
      state: 'SHIPPED',
      shippedDetail: body.shippedDetail,
    },
  })
}

export function getSynonyms(projectId) {
  return get(`/ecommerce/project/${projectId}/synonyms`)
}

export function updateSynonyms(projectId, body) {
  return post(`/ecommerce/project/${projectId}/synonyms`, body)
}

export function cancelOrder({projectId, orderId, cancelReason}) {
  return post(`/ecommerce/project/${projectId}/order/${orderId}/cancel`, {
    action: 'cancel',
    data: {
      reason: cancelReason,
    },
  })
}



// WEBPACK FOOTER //
// ./src/functions/ecommerce/index.js